import { useLocalSearchParams } from 'expo-router';

import { ManualSwitch } from '../../../../banking/components/direct-deposit/ManualSwitch';
import type { DirectDepositSwitchAppContext } from '../../../../banking/components/direct-deposit/types';

const ManualSwitchPage = () => {
    const { bankAccountId, context, source } = useLocalSearchParams<{
        bankAccountId?: string;
        context?: DirectDepositSwitchAppContext;
        source?: string;
    }>();
    return (
        <ManualSwitch
            defaultBankAccountId={bankAccountId}
            context={context}
            source={source}
        />
    );
};

export default ManualSwitchPage;
